import "./TeamItem.scss";
import { useTranslation } from "react-i18next";
import { normalizeColor } from "../../../../utils/colors";

function TeamItem({ name, memberCount, color, onClick, isSelected, onDelete }) {
  const { t } = useTranslation();
  const hexColor = normalizeColor(color);

  const handleDeleteClick = (e) => {
    e.stopPropagation(); // Prevent triggering onClick
    if (onDelete) {
      onDelete();
    }
  };

  return (
    <div
      className={`team-item ${isSelected ? "selected" : ""}`}
      onClick={onClick}
    >
      <div
        className="color-indicator"
        style={{ backgroundColor: hexColor }}
      ></div>
      <div className="team-info">
        <div className="team-name">{name}</div>
        <div className="team-members">
          {t("organizations.memberCount", { count: memberCount || 0 })}
        </div>
      </div>
      <button className="delete-button" onClick={handleDeleteClick}>
        <span className="material-symbols-outlined">delete</span>
      </button>
    </div>
  );
}

export default TeamItem;
